import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PortalLayout from '../components/layout/PortalLayout';
import { NavItem } from '../components/layout/PortalSidebar';
import ContractorDashboard from '../pages/contractor/ContractorDashboard';

const navItems: NavItem[] = [
  { label: 'Dashboard', icon: 'LayoutDashboard', to: '/contractor/dashboard' },
  { label: 'My Jobs', icon: 'HardHat', to: '/contractor/jobs' },
  { label: 'Schedule', icon: 'Calendar', to: '/contractor/schedule' },
  { label: 'Work Orders', icon: 'ClipboardList', to: '/contractor/work-orders' },
  { label: 'Earnings', icon: 'DollarSign', to: '/contractor/earnings' },
  { label: 'Documents', icon: 'FolderOpen', to: '/contractor/documents' },
  { label: 'My Profile', icon: 'User', to: '/contractor/profile' },
];

const ComingSoon: React.FC<{ title: string }> = ({ title }) => (
  <div style={{ textAlign: 'center', padding: '4rem 2rem' }}>
    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔧</div>
    <h2 style={{ fontWeight: 700, color: 'var(--text-primary)', marginBottom: '0.5rem' }}>{title}</h2>
    <p style={{ color: 'var(--text-muted)' }}>This section is designed and ready for backend integration.</p>
  </div>
);

const ContractorRoutes: React.FC = () => (
  <PortalLayout navItems={navItems} title="Contractor Portal" subtitle="Contractor Portal">
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<ContractorDashboard />} />
      <Route path="jobs" element={<ComingSoon title="My Jobs" />} />
      <Route path="schedule" element={<ComingSoon title="My Schedule" />} />
      <Route path="work-orders" element={<ComingSoon title="Work Orders" />} />
      <Route path="earnings" element={<ComingSoon title="Earnings & Payouts" />} />
      <Route path="documents" element={<ComingSoon title="Documents" />} />
      <Route path="profile" element={<ComingSoon title="My Profile" />} />
    </Routes>
  </PortalLayout>
);

export default ContractorRoutes;
